"use client";

import { c as _c } from "react/compiler-runtime";
import type { Orientation } from "../types";
import { useCallback, useRef, useState } from "react";
import { FiArrowDown, FiArrowRight, FiPrinter } from "react-icons/fi";
import Button from "@/components/ui/button";
import { Dialog, DialogBody, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { RadioCardGroup, RadioCardItem } from "@/components/ui/radio-card-group";
import { CarePlanPrintGraphStyles, CarePlanPrintPreview } from "./care-plan-print-preview";
export function CarePlanPrintDialog(t0) {
  const $ = _c(38);
  const {
    open,
    onOpenChange,
    onConfirm,
    isPrinting: t1
  } = t0;
  const isPrinting = t1 === undefined ? false : t1;
  const [direction, setDirection] = useState("horizontal");
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {};
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const snapshots = useRef(t2);
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      horizontal: false,
      vertical: false
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const [ready, setReady] = useState(t3);
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      horizontal: false,
      vertical: false
    };
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const [errors, setErrors] = useState(t4);
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = (choice, canvas, error) => {
      if (canvas) {
        snapshots.current[choice] = canvas;
      } else {
        delete snapshots.current[choice];
      }
      setReady(previous => previous[choice] === !!canvas ? previous : {
        ...previous,
        [choice]: !!canvas
      });
      setErrors(previous_0 => previous_0[choice] === !!error ? previous_0 : {
        ...previous_0,
        [choice]: !!error
      });
    };
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const handleReady = t5;
  let t6;
  if ($[4] !== isPrinting || $[5] !== onOpenChange) {
    t6 = next => {
      if (!isPrinting) {
        onOpenChange(next);
      }
    };
    $[4] = isPrinting;
    $[5] = onOpenChange;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <DialogHeader><DialogTitle>Print care plan</DialogTitle><DialogDescription>Choose how the steps are arranged.</DialogDescription></DialogHeader>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== direction || $[9] !== errors || $[10] !== isPrinting || $[11] !== open) {
    t8 = open && <><CarePlanPrintGraphStyles /><RadioCardGroup aria-label="Step direction" value={direction} onValueChange={value => {
        if (value === "horizontal" || value === "vertical") {
          setDirection(value);
        }
      }} disabled={isPrinting} className="grid-cols-1 sm:grid-cols-2 gap-4">{(["horizontal", "vertical"] as const).map(choice_0 => <RadioCardItem key={choice_0} value={choice_0} aria-label={choice_0 === "horizontal" ? "Left to right" : "Top to bottom"} className="rounded-xl p-3 shadow-none data-[state=checked]:bg-background data-[state=checked]:ring-1 data-[state=checked]:ring-primary/25"><div className="flex w-full items-center gap-2.5 pr-6"><span className="flex size-8 shrink-0 items-center justify-center rounded-lg bg-background-secondary text-foreground-secondary group-data-[state=checked]:text-primary" aria-hidden="true">{choice_0 === "horizontal" ? <FiArrowRight className="size-4" /> : <FiArrowDown className="size-4" />}</span><span className="text-body-emphasis text-foreground">{choice_0 === "horizontal" ? "Left to right" : "Top to bottom"}</span></div><CarePlanPrintPreview direction={choice_0} onReady={handleReady} /></RadioCardItem>)}</RadioCardGroup>{(errors.horizontal || errors.vertical) && <p role="alert" className="mt-3 text-body text-status-error-text">The preview could not be prepared. Close this window and try again.</p>}</>;
    $[8] = direction;
    $[9] = errors;
    $[10] = isPrinting;
    $[11] = open;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t8) {
    t9 = <DialogBody className="max-h-[70vh] overflow-y-auto">{t8}</DialogBody>;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== onOpenChange) {
    t10 = () => onOpenChange(false);
    $[15] = onOpenChange;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== isPrinting || $[18] !== t10) {
    t11 = <Button variant="secondary" className="h-10 min-w-20" disabled={isPrinting} onClick={t10}>Cancel</Button>;
    $[17] = isPrinting;
    $[18] = t10;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  const t12 = isPrinting || !ready.horizontal || !ready.vertical;
  let t13;
  if ($[20] !== direction || $[21] !== isPrinting || $[22] !== onConfirm) {
    t13 = () => {
      const canvas_0 = snapshots.current[direction];
      if (canvas_0 && !isPrinting) {
        onConfirm(direction, canvas_0);
      }
    };
    $[20] = direction;
    $[21] = isPrinting;
    $[22] = onConfirm;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== isPrinting || $[25] !== t12 || $[26] !== t13) {
    t14 = <Button variant="primary" icon={FiPrinter} className="h-10 min-w-28" isLoading={isPrinting} disabled={t12} onClick={t13}>Print</Button>;
    $[24] = isPrinting;
    $[25] = t12;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t11 || $[29] !== t14) {
    t15 = <DialogFooter>{t11}{t14}</DialogFooter>;
    $[28] = t11;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t15 || $[32] !== t9) {
    t16 = <DialogContent className="max-w-2xl">{t7}{t9}{t15}</DialogContent>;
    $[31] = t15;
    $[32] = t9;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== open || $[35] !== t16 || $[36] !== t6) {
    t17 = <Dialog open={open} onOpenChange={t6}>{t16}</Dialog>;
    $[34] = open;
    $[35] = t16;
    $[36] = t6;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  return t17;
}